(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class CategoryScrollbar extends HTMLElement {
    connectedCallback() {
      this.slider = this.parentElement.querySelector('.collection-list');
      if (!this.slider) return;
      this.onScroll = () => this.update();
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.slider);
      this.update();
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    update() {
      const { clientWidth, scrollWidth, scrollLeft } = this.slider;
      const maxOffset = scrollWidth - clientWidth;
      this.hidden = maxOffset <= 1;
      if (this.hidden) return;
      const offset = Math.max(0, Math.min(scrollLeft, maxOffset));
      this.style.setProperty('--category-scroll-size', `${clientWidth / scrollWidth * 100}%`);
      this.style.setProperty('--category-scroll-offset', `${offset / scrollWidth * 100}%`);
    }
  }

  if (!customElements.get('category-scrollbar')) {
    customElements.define('category-scrollbar', CategoryScrollbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.fcc-track');
      this.viewport = this.querySelector('.fcc-viewport');
      this.scrollbar = this.querySelector('.fcc-scrollbar');
      this.section = this.closest('.fcc-section');
      this.prevBtn = this.section?.querySelector('.fcc-nav-prev');
      this.nextBtn = this.section?.querySelector('.fcc-nav-next');

      // Variant Modal elements
      this.variantModal = this.section?.querySelector('.fcc-variant-modal');
      this.variantOverlay = this.variantModal?.querySelector('.fcc-variant-modal__overlay');
      this.variantClose = this.variantModal?.querySelector('.fcc-variant-modal__close');
      this.variantImg = this.variantModal?.querySelector('.fcc-variant-modal__img');
      this.variantTitle = this.variantModal?.querySelector('.fcc-variant-modal__product-title');
      this.variantPrice = this.variantModal?.querySelector('.fcc-variant-modal__product-price');
      this.variantOptionsBody = this.variantModal?.querySelector('.fcc-variant-modal__options-body');
      this.variantSubmitBtn = this.variantModal?.querySelector('.fcc-variant-modal__submit-btn');

      // Toast element
      this.toast = this.section?.querySelector('.fcc-toast');

      this.currentIndex = 0;
      this.isDragging = false;
      this.dragMoved = false;
      this.startX = 0;
      this.startY = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationId = null;
      this.originalLength = 0;
      this.toastTimer = null;
      this.currentProductData = null;
      this.selectedOptions = [];

      this.init();
    }

    init() {
      if (!this.track) return;
      this.originalItems = Array.from(this.track.children);
      this.originalLength = this.originalItems.length;

      if (this.originalLength < 1) return;

      this.currentIndex = 0;
      this.updatePosition(false);

      // Nav buttons
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slidePrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideNext());

      // Touch / Drag events
      this.viewport.addEventListener('mousedown', this.dragStart.bind(this));
      this.viewport.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });

      window.addEventListener('mousemove', this.dragMove.bind(this));
      window.addEventListener('touchmove', this.dragMove.bind(this), { passive: true });

      window.addEventListener('mouseup', this.dragEnd.bind(this));
      window.addEventListener('touchend', this.dragEnd.bind(this));

      window.addEventListener('resize', () => this.updatePosition(false));

      // Setup Cards Interaction
      this.setupCardClicks();

      // Setup Variant Modal Event listeners
      if (this.variantOverlay) this.variantOverlay.addEventListener('click', () => this.closeVariantModal());
      if (this.variantClose) this.variantClose.addEventListener('click', () => this.closeVariantModal());

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.variantModal && !this.variantModal.hasAttribute('hidden')) {
          this.closeVariantModal();
        }
      });
    }

    getStepWidth() {
      const firstCard = this.track.children[0];
      if (!firstCard) return 0;
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    updatePosition(animated = true) {
      const stepWidth = this.getStepWidth();
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const maxOffset = Math.max(0, stepWidth * this.originalLength - gap - this.viewport.getBoundingClientRect().width);
      const maxIndex = stepWidth ? Math.ceil(maxOffset / stepWidth - 0.001) : 0;
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex));
      this.currentTranslate = -Math.min(this.currentIndex * stepWidth, maxOffset);
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === maxIndex;
      this.prevTranslate = this.currentTranslate;

      if (!animated) {
        this.track.classList.add('no-transition');
      } else {
        this.track.classList.remove('no-transition');
      }

      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
      this.updateScrollbar();

      if (!animated) {
        this.track.offsetHeight; // force reflow
        this.track.classList.remove('no-transition');
      }
    }

    updateScrollbar() {
      if (!this.scrollbar) return;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const contentWidth = this.getStepWidth() * this.originalLength - gap;
      const viewportWidth = this.viewport.clientWidth;
      const maxOffset = Math.max(0, contentWidth - viewportWidth);
      this.scrollbar.hidden = maxOffset <= 1;
      if (maxOffset <= 1) return;
      const offset = Math.max(0, Math.min(-this.currentTranslate, maxOffset));
      this.scrollbar.style.setProperty('--fcc-scroll-size', `${viewportWidth / contentWidth * 100}%`);
      this.scrollbar.style.setProperty('--fcc-scroll-offset', `${offset / contentWidth * 100}%`);
    }

    slideNext() {
      this.currentIndex++;
      this.updatePosition(true);
    }

    slidePrev() {
      this.currentIndex--;
      this.updatePosition(true);
    }

    dragStart(e) {
      this.isDragging = true;
      this.viewport.classList.add('is-dragging');
      this.dragMoved = false;
      this.startX = this.getPositionX(e);
      this.startY = this.getPositionY(e);
      this.track.classList.add('no-transition');
      this.animationId = requestAnimationFrame(this.animation.bind(this));
    }

    dragMove(e) {
      if (!this.isDragging) return;
      const currentX = this.getPositionX(e);
      const currentY = this.getPositionY(e);
      const diffX = currentX - this.startX;
      const diffY = currentY - this.startY;

      if (Math.abs(diffX) > 8 || Math.abs(diffY) > 8) {
        this.dragMoved = true;
      }

      this.currentTranslate = this.prevTranslate + diffX;
    }

    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');
      cancelAnimationFrame(this.animationId);

      const movedBy = this.currentTranslate - this.prevTranslate;

      if (movedBy < -40) {
        this.currentIndex++;
      } else if (movedBy > 40) {
        this.currentIndex--;
      }

      this.updatePosition(true);
    }

    getPositionX(e) {
      return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    }

    getPositionY(e) {
      return e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    }

    animation() {
      if (this.isDragging) {
        this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        this.updateScrollbar();
        this.animationId = requestAnimationFrame(this.animation.bind(this));
      }
    }

    setupCardClicks() {
      this.track.querySelectorAll('.fcc-card-item').forEach((cardItem) => {
        const card = cardItem.querySelector('.fcc-card');
        const addToCartBtn = cardItem.querySelector('.fcc-card__add-btn');
        const jsonScript = cardItem.querySelector('.fcc-product-json');
        const productUrl = card?.getAttribute('data-product-url');

        // Add to cart click handler
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (jsonScript) {
              try {
                const productData = JSON.parse(jsonScript.textContent);
                this.onAddToCartClick(productData, addToCartBtn);
              } catch (err) {
                const variantId = addToCartBtn.getAttribute('data-variant-id');
                this.executeAddToCart(variantId, addToCartBtn);
              }
            } else {
              const variantId = addToCartBtn.getAttribute('data-variant-id');
              this.executeAddToCart(variantId, addToCartBtn);
            }
          });
        }

        // Card click handler (navigates to product page if not dragging and not clicking add to cart)
        if (card) {
          card.addEventListener('click', (e) => {
            if (this.dragMoved) return;
            if (e.target.closest('.fcc-card__add-btn')) return;
            if (productUrl) {
              window.location.href = productUrl;
            }
          });

          card.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              if (e.target.closest('.fcc-card__add-btn')) return;
              e.preventDefault();
              if (productUrl) window.location.href = productUrl;
            }
          });
        }
      });
    }

    onAddToCartClick(productData, button) {
      if (!productData) return;

      if (productData.has_only_default_variant || !productData.variants || productData.variants.length <= 1) {
        const variantId = (productData.variants && productData.variants[0]) ? productData.variants[0].id : button.getAttribute('data-variant-id');
        this.executeAddToCart(variantId, button, productData.title);
      } else {
        this.openVariantModal(productData, button);
      }
    }

    openVariantModal(productData, triggerButton) {
      if (!this.variantModal) return;

      this.currentProductData = productData;
      this.currentTriggerButton = triggerButton;

      if (this.variantImg) this.variantImg.src = productData.featured_image || '';
      if (this.variantTitle) this.variantTitle.textContent = productData.title;

      this.selectedOptions = productData.options.map((opt) => opt.values[0]);

      this.renderVariantOptions();
      this.updateSelectedVariantState();

      this.variantModal.removeAttribute('hidden');
    }

    renderVariantOptions() {
      if (!this.variantOptionsBody || !this.currentProductData) return;

      this.variantOptionsBody.innerHTML = '';

      this.currentProductData.options.forEach((opt, optIdx) => {
        const group = document.createElement('div');
        group.className = 'fcc-variant-modal__options-group';

        const label = document.createElement('span');
        label.className = 'fcc-variant-modal__option-label';
        label.textContent = opt.name;
        group.appendChild(label);

        const pillsContainer = document.createElement('div');
        pillsContainer.className = 'fcc-variant-modal__pills';

        opt.values.forEach((val) => {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = `fcc-variant-pill ${this.selectedOptions[optIdx] === val ? 'selected' : ''}`;
          pill.textContent = val;

          pill.addEventListener('click', () => {
            this.selectedOptions[optIdx] = val;
            this.renderVariantOptions();
            this.updateSelectedVariantState();
          });

          pillsContainer.appendChild(pill);
        });

        group.appendChild(pillsContainer);
        this.variantOptionsBody.appendChild(group);
      });
    }

    findMatchingVariant() {
      if (!this.currentProductData || !this.currentProductData.variants) return null;
      return this.currentProductData.variants.find((v) => {
        return v.options.every((optVal, idx) => optVal === this.selectedOptions[idx]);
      });
    }

    updateSelectedVariantState() {
      const matched = this.findMatchingVariant();

      if (matched) {
        if (this.variantPrice) this.variantPrice.textContent = matched.price;

        if (matched.available) {
          this.variantSubmitBtn.disabled = false;
          this.variantSubmitBtn.querySelector('span').textContent = 'Add to cart';
        } else {
          this.variantSubmitBtn.disabled = true;
          this.variantSubmitBtn.querySelector('span').textContent = 'Sold out';
        }

        this.variantSubmitBtn.onclick = () => {
          this.closeVariantModal();
          this.executeAddToCart(matched.id, this.currentTriggerButton, `${this.currentProductData.title} (${matched.title})`);
        };
      } else {
        if (this.variantPrice) this.variantPrice.textContent = '';
        this.variantSubmitBtn.disabled = true;
        this.variantSubmitBtn.querySelector('span').textContent = 'Unavailable';
      }
    }

    closeVariantModal() {
      if (!this.variantModal) return;
      this.variantModal.setAttribute('hidden', '');
    }

    executeAddToCart(variantId, button, customTitle = '') {
      if (!variantId || button?.dataset.cartPending === 'true') return;

      if (button) {
        button.disabled = true;
        button.dataset.cartPending = 'true';
      }
      const textSpan = button?.querySelector('.fcc-btn-text');
      const plusIcon = button?.querySelector('.fcc-icon-plus');
      const checkIcon = button?.querySelector('.fcc-icon-check');

      const originalText = textSpan ? textSpan.textContent : '';
      if (textSpan) textSpan.textContent = 'Adding...';

      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
        : 'cart-drawer,cart-icon-bubble';

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }

      const previousRequest = window.bonezCartAddQueue || Promise.resolve();
      const currentRequest = previousRequest
        .catch(() => {})
        .then(() => this.requestCartAdd(variantId, sectionsToRender))
        .then((data) => {
          // 1. Notify Dawn PubSub event if active
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'featured-collection-carousel',
              productVariantId: variantId,
              cartData: data,
            });
          }

          // 2. Update and open Cart Drawer / Notification using native Dawn component
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else {
            // Fallback: manually update cart icon bubble
            if (data.sections && data.sections['cart-icon-bubble']) {
              const bubbleHtml = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const newBubble = bubbleHtml.querySelector('#cart-icon-bubble') || bubbleHtml.querySelector('.shopify-section');
              const currentBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
            }
          }
          if (cartDrawer?.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

          // 3. Show Toast feedback
          const message = customTitle ? `${customTitle} added to cart!` : 'Item added to cart!';
          this.showToastMessage(message);

          // 4. Button feedback animation
          if (textSpan) textSpan.textContent = 'Added!';
          if (plusIcon) plusIcon.classList.add('hidden');
          if (checkIcon) checkIcon.classList.remove('hidden');

          setTimeout(() => {
            if (textSpan) textSpan.textContent = originalText || 'Add to cart';
            if (plusIcon) plusIcon.classList.remove('hidden');
            if (checkIcon) checkIcon.classList.add('hidden');
            if (button) {
              button.disabled = false;
              delete button.dataset.cartPending;
            }
          }, 1500);
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          if (textSpan) textSpan.textContent = originalText || 'Add to cart';
          if (plusIcon) plusIcon.classList.remove('hidden');
          if (checkIcon) checkIcon.classList.add('hidden');
          if (button) {
            button.disabled = false;
            delete button.dataset.cartPending;
          }
        });

      window.bonezCartAddQueue = currentRequest.catch(() => {});
    }

    async requestCartAdd(variantId, sectionsToRender) {
      const maxAttempts = 4;

      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const responseText = await response.text();
        let data = null;

        try {
          data = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          data = null;
        }

        if (response.status === 429 && attempt < maxAttempts - 1) {
          await new Promise((resolve) => setTimeout(resolve, this.getCartRetryDelay(response, attempt)));
          continue;
        }

        if (!response.ok || data?.status) {
          throw new Error(data?.description || data?.message || `Could not add item to cart (${response.status})`);
        }

        if (!data) throw new Error('Could not read the cart response');
        return data;
      }

      throw new Error('Could not add item to cart');
    }

    getCartRetryDelay(response, attempt) {
      const retryAfter = response.headers.get('Retry-After');
      const retryAfterSeconds = Number.parseFloat(retryAfter);

      if (Number.isFinite(retryAfterSeconds)) {
        return Math.max(250, retryAfterSeconds * 1000);
      }

      const retryDate = retryAfter ? Date.parse(retryAfter) : NaN;
      if (!Number.isNaN(retryDate)) {
        return Math.max(250, retryDate - Date.now());
      }

      return 2000 * (2 ** attempt);
    }

    showToastMessage(msg) {
      if (!this.toast) return;

      const msgEl = this.toast.querySelector('.fcc-toast__message');
      if (msgEl) msgEl.textContent = msg;

      this.toast.classList.add('active');

      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.classList.remove('active');
      }, 3500);
    }
  }

  if (!customElements.get('featured-collection-carousel')) {
    customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.fp-carousel-track');
      this.viewport = this.querySelector('.fp-carousel-viewport');
      this.scrollbar = this.querySelector('.fp-carousel-scrollbar');
      this.prevBtn = this.closest('.fp-carousel-section')?.querySelector('.fp-nav-prev');
      this.nextBtn = this.closest('.fp-carousel-section')?.querySelector('.fp-nav-next');

      this.currentIndex = 0;
      this.isDragging = false;
      this.hasDragged = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationId = null;
      this.originalLength = 0;

      this.init();
    }

    init() {
      if (!this.track) return;
      this.originalItems = Array.from(this.track.children);
      this.originalLength = this.originalItems.length;

      if (this.originalLength < 1) return;

      this.currentIndex = 0;
      this.updatePosition(false);

      // Event listeners for Navigation Buttons
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slidePrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideNext());

      // Prevent click navigation if dragging occurred
      this.viewport.addEventListener(
        'click',
        (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopPropagation();
            this.hasDragged = false;
          }
        },
        true
      );

      // Prevent native browser link/image dragging so custom carousel drag works everywhere
      this.viewport.addEventListener('dragstart', (e) => e.preventDefault());

      // Drag / Touch Events
      this.viewport.addEventListener('mousedown', this.dragStart.bind(this));
      this.viewport.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });

      window.addEventListener('mousemove', this.dragMove.bind(this));
      window.addEventListener('touchmove', this.dragMove.bind(this), { passive: true });

      window.addEventListener('mouseup', this.dragEnd.bind(this));
      window.addEventListener('touchend', this.dragEnd.bind(this));

      // Handle Resize
      window.addEventListener('resize', () => this.updatePosition(false));


    }

    getStepWidth() {
      const firstCard = this.track.children[0];
      if (!firstCard) return 0;
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    updatePosition(animated = true) {
      const stepWidth = this.getStepWidth();
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const maxOffset = Math.max(0, stepWidth * this.originalLength - gap - this.viewport.getBoundingClientRect().width);
      const maxIndex = stepWidth ? Math.ceil(maxOffset / stepWidth - 0.001) : 0;
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex));
      this.currentTranslate = -Math.min(this.currentIndex * stepWidth, maxOffset);
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === maxIndex;
      this.prevTranslate = this.currentTranslate;

      if (!animated) {
        this.track.classList.add('no-transition');
      } else {
        this.track.classList.remove('no-transition');
      }

      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
      this.updateScrollbar();

      if (!animated) {
        // Force reflow
        this.track.offsetHeight;
        this.track.classList.remove('no-transition');
      }
    }

    updateScrollbar() {
      if (!this.scrollbar) return;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const contentWidth = this.getStepWidth() * this.originalLength - gap;
      const viewportWidth = this.viewport.clientWidth;
      const maxOffset = Math.max(0, contentWidth - viewportWidth);
      this.scrollbar.hidden = maxOffset <= 1;
      if (maxOffset <= 1) return;
      const offset = Math.max(0, Math.min(-this.currentTranslate, maxOffset));
      this.scrollbar.style.setProperty('--fp-scroll-size', `${viewportWidth / contentWidth * 100}%`);
      this.scrollbar.style.setProperty('--fp-scroll-offset', `${offset / contentWidth * 100}%`);
    }

    slideNext() {
      this.currentIndex++;
      this.updatePosition(true);
    }

    slidePrev() {
      this.currentIndex--;
      this.updatePosition(true);
    }

    dragStart(e) {
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = this.getPositionX(e);
      this.startTime = Date.now();
      this.track.classList.add('no-transition');
      this.viewport.classList.add('is-dragging');
      this.animationId = requestAnimationFrame(this.animation.bind(this));
    }

    dragMove(e) {
      if (!this.isDragging) return;
      const currentX = this.getPositionX(e);
      const diffX = currentX - this.startX;
      if (Math.abs(diffX) > 6) {
        this.hasDragged = true;
      }
      this.currentTranslate = this.prevTranslate + diffX;
    }

    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');
      cancelAnimationFrame(this.animationId);

      const stepWidth = this.getStepWidth();
      if (!stepWidth) return;

      const timeElapsed = Date.now() - this.startTime;
      const movedBy = this.currentTranslate - this.prevTranslate;
      const velocity = movedBy / (timeElapsed || 1);

      // Calculate fluid momentum displacement based on distance and velocity
      let projectedDistance = movedBy + velocity * 120;
      let cardShift = Math.round(-projectedDistance / stepWidth);

      // Ensure quick short flicks advance at least 1 card if user moved > 15px
      if (cardShift === 0 && Math.abs(movedBy) > 15) {
        cardShift = movedBy < 0 ? 1 : -1;
      }

      this.currentIndex += cardShift;
      this.updatePosition(true);
    }

    getPositionX(e) {
      return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    }

    animation() {
      if (this.isDragging) {
        this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        this.updateScrollbar();
        this.animationId = requestAnimationFrame(this.animation.bind(this));
      }
    }
  }

  if (!customElements.get('featured-products-carousel')) {
    customElements.define('featured-products-carousel', FeaturedProductsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
  class InstagramCarousel extends HTMLElement {
    constructor() {
      super();
      this.viewport = null;
      this.track = null;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
      this.targetX = 0;
      this.dragStartX = 0;
      this.dragDistance = 0;
      this.velocity = 0;
      this.lastPointerX = 0;
      this.lastPointerTime = 0;
      this.singleSetWidth = 0;
      this.baseOffset = 0;
      this.animFrameId = null;
      this.isHovered = false;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
      this.tick = this.tick.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.viewport || !this.track) return;

      this.autoScrollEnabled = this.dataset.autoscroll === 'true';
      const speedPercent = parseFloat(this.dataset.speed || '100');
      this.autoScrollSpeed = 0.375 * (speedPercent / 100);

      this.initCarousel();

      // Events
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('click', this.onClickCapture, true);
      window.addEventListener('resize', this.handleResize);

      this.addEventListener('mouseenter', () => (this.isHovered = true));
      this.addEventListener('mouseleave', () => (this.isHovered = false));

      this.animFrameId = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      if (this.animFrameId) cancelAnimationFrame(this.animFrameId);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
      window.removeEventListener('resize', this.handleResize);
    }

    initCarousel() {
      const baseItems = Array.from(this.track.children);
      if (baseItems.length === 0) return;

      // Duplicate elements if necessary so we have at least 18 items (3 sets) for seamless infinite scrolling
      const targetMinItems = Math.max(18, baseItems.length * 3);
      while (this.track.children.length < targetMinItems) {
        baseItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-cloned', 'true');
          this.track.appendChild(clone);
        });
      }

      this.calculateDimensions();
    }

    calculateDimensions() {
      if (!this.track || this.track.children.length === 0) return;

      const items = Array.from(this.track.children);
      const firstItem = items[0];
      const cardWidth = firstItem.getBoundingClientRect().width;

      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 12;

      // Calculate width of one original set of items
      const originalCount =
        this.querySelectorAll('.igc-card-item:not([data-cloned="true"])')
          .length || items.length / 3;

      this.singleSetWidth = (cardWidth + gap) * originalCount;

      // Desktop vs Mobile offset calculation
      const isDesktop = window.innerWidth >= 750;
      if (isDesktop) {
        // Desktop: 1st and last cards cut in half -> initial offset = -0.5 * (cardWidth + gap)
        this.baseOffset = -0.5 * (cardWidth + gap);
      } else {
        // Mobile: 1st card 100% visible on left edge
        this.baseOffset = 20; // 20px padding from screen edge
      }

      // Reset positions to middle set for smooth infinite drag in both directions
      if (this.currentX === 0) {
        this.currentX = this.baseOffset - this.singleSetWidth;
        this.targetX = this.currentX;
      }
    }

    handleResize() {
      this.calculateDimensions();
    }

    onPointerDown(e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;

      this.isDragging = true;
      this.startX = e.clientX;
      this.dragStartX = e.clientX;
      this.dragDistance = 0;
      this.lastPointerX = e.clientX;
      this.lastPointerTime = performance.now();
      this.velocity = 0;

      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture(e.pointerId);
    }

    onPointerMove(e) {
      if (!this.isDragging) return;

      const deltaX = e.clientX - this.startX;
      this.startX = e.clientX;
      this.targetX += deltaX;
      this.currentX += deltaX;

      this.dragDistance += Math.abs(e.clientX - this.dragStartX);

      // Velocity calculation
      const now = performance.now();
      const dt = now - this.lastPointerTime;
      if (dt > 0) {
        this.velocity = (e.clientX - this.lastPointerX) / dt;
        this.lastPointerX = e.clientX;
        this.lastPointerTime = now;
      }
    }

    onPointerUp(e) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');

      try {
        if (this.viewport.hasPointerCapture(e.pointerId)) {
          this.viewport.releasePointerCapture(e.pointerId);
        }
      } catch (err) {
        // Ignored
      }
    }

    onClickCapture(e) {
      // Prevent link activation if user dragged more than 6px
      if (this.dragDistance > 6) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    tick() {
      if (!this.isDragging) {
        // Friction decay for inertial drag
        if (Math.abs(this.velocity) > 0.05) {
          this.targetX += this.velocity * 16;
          this.velocity *= 0.92;
        } else {
          this.velocity = 0;
          // Auto-scroll if enabled and not hovered
          if (this.autoScrollEnabled && !this.isHovered) {
            this.targetX -= this.autoScrollSpeed;
          }
        }

        // Smooth easing towards target position
        this.currentX += (this.targetX - this.currentX) * 0.25;
      }

      // Wrap around logic for infinite loop
      if (this.singleSetWidth > 0) {
        const minBound = this.baseOffset - this.singleSetWidth * 2;
        const maxBound = this.baseOffset;

        if (this.currentX < minBound) {
          this.currentX += this.singleSetWidth;
          this.targetX += this.singleSetWidth;
        } else if (this.currentX > maxBound) {
          this.currentX -= this.singleSetWidth;
          this.targetX -= this.singleSetWidth;
        }
      }

      // Apply transform
      this.track.style.transform = `translate3d(${this.currentX}px, 0, 0)`;

      this.animFrameId = requestAnimationFrame(this.tick);
    }
  }

  if (!customElements.get('instagram-carousel')) {
    customElements.define('instagram-carousel', InstagramCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.vrc-track');
      this.viewport = this.querySelector('.vrc-viewport');
      this.section = this.closest('.vrc-section');
      this.prevBtn = this.section?.querySelector('.vrc-nav-prev');
      this.nextBtn = this.section?.querySelector('.vrc-nav-next');
      this.lightbox = this.section?.querySelector('.vrc-lightbox');
      this.lightboxOverlay = this.lightbox?.querySelector('.vrc-lightbox__overlay');
      this.lightboxClose = this.lightbox?.querySelector('.vrc-lightbox__close');
      this.lightboxVideo = this.lightbox?.querySelector('.vrc-lightbox__video');

      // Variant Modal elements
      this.variantModal = this.section?.querySelector('.vrc-variant-modal');
      this.variantOverlay = this.variantModal?.querySelector('.vrc-variant-modal__overlay');
      this.variantClose = this.variantModal?.querySelector('.vrc-variant-modal__close');
      this.variantImg = this.variantModal?.querySelector('.vrc-variant-modal__img');
      this.variantTitle = this.variantModal?.querySelector('.vrc-variant-modal__product-title');
      this.variantPrice = this.variantModal?.querySelector('.vrc-variant-modal__product-price');
      this.variantOptionsBody = this.variantModal?.querySelector('.vrc-variant-modal__options-body');
      this.variantSubmitBtn = this.variantModal?.querySelector('.vrc-variant-modal__submit-btn');

      // Toast element
      this.toast = this.section?.querySelector('.vrc-toast');

      this.currentIndex = 0;
      this.isDragging = false;
      this.dragMoved = false;
      this.startX = 0;
      this.startY = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationId = null;
      this.clonedCount = 0;
      this.originalLength = 0;
      this.activeTimer = null;
      this.activeCard = null;
      this.toastTimer = null;
      this.currentProductData = null;
      this.selectedOptions = [];

      this.init();
    }

    init() {
      if (!this.track) return;
      this.originalItems = Array.from(this.track.children);
      this.originalLength = this.originalItems.length;

      if (this.originalLength < 1) return;

      // Infinite loop clones setup
      this.clonedCount = Math.max(3, this.originalLength);

      for (let i = 0; i < this.clonedCount; i++) {
        const cloneEnd = this.originalItems[i % this.originalLength].cloneNode(true);
        cloneEnd.classList.add('vrc-clone');
        this.track.appendChild(cloneEnd);
      }

      for (let i = 0; i < this.clonedCount; i++) {
        const idx = (this.originalLength - 1 - (i % this.originalLength) + this.originalLength) % this.originalLength;
        const cloneStart = this.originalItems[idx].cloneNode(true);
        cloneStart.classList.add('vrc-clone');
        this.track.insertBefore(cloneStart, this.track.firstChild);
      }

      this.currentIndex = this.clonedCount;
      this.updatePosition(false);

      // Nav buttons
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slidePrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideNext());

      // Touch / Drag events
      this.viewport.addEventListener('mousedown', this.dragStart.bind(this));
      this.viewport.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });

      window.addEventListener('mousemove', this.dragMove.bind(this));
      window.addEventListener('touchmove', this.dragMove.bind(this), { passive: true });

      window.addEventListener('mouseup', this.dragEnd.bind(this));
      window.addEventListener('touchend', this.dragEnd.bind(this));

      // Transition end loop check
      this.track.addEventListener('transitionend', () => this.checkLoopBoundary());
      window.addEventListener('resize', () => this.updatePosition(false));

      // Setup Cards Interaction
      this.setupCardHoverAndClicks();

      // Setup Lightbox Event listeners
      if (this.lightboxOverlay) this.lightboxOverlay.addEventListener('click', () => this.closeLightbox());
      if (this.lightboxClose) this.lightboxClose.addEventListener('click', () => this.closeLightbox());

      // Setup Variant Modal Event listeners
      if (this.variantOverlay) this.variantOverlay.addEventListener('click', () => this.closeVariantModal());
      if (this.variantClose) this.variantClose.addEventListener('click', () => this.closeVariantModal());

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.variantModal && !this.variantModal.hasAttribute('hidden')) {
            this.closeVariantModal();
          } else if (this.lightbox && !this.lightbox.hasAttribute('hidden')) {
            this.closeLightbox();
          }
        }
      });
    }

    getStepWidth() {
      const firstCard = this.track.children[0];
      if (!firstCard) return 0;
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 0;
      return firstCard.offsetWidth + gap;
    }

    updatePosition(animated = true) {
      const stepWidth = this.getStepWidth();
      this.currentTranslate = -this.currentIndex * stepWidth;
      this.prevTranslate = this.currentTranslate;

      if (!animated) {
        this.track.classList.add('no-transition');
      } else {
        this.track.classList.remove('no-transition');
      }

      this.track.style.transform = `translateX(${this.currentTranslate}px)`;

      if (!animated) {
        this.track.offsetHeight; // force reflow
        this.track.classList.remove('no-transition');
      }
    }

    slideNext() {
      this.currentIndex++;
      this.updatePosition(true);
    }

    slidePrev() {
      this.currentIndex--;
      this.updatePosition(true);
    }

    checkLoopBoundary() {
      if (this.currentIndex >= this.originalLength + this.clonedCount) {
        this.currentIndex = this.currentIndex - this.originalLength;
        this.updatePosition(false);
      } else if (this.currentIndex < this.clonedCount) {
        this.currentIndex = this.currentIndex + this.originalLength;
        this.updatePosition(false);
      }
    }

    dragStart(e) {
      this.isDragging = true;
      this.dragMoved = false;
      this.startX = this.getPositionX(e);
      this.startY = this.getPositionY(e);
      this.track.classList.add('no-transition');
      this.animationId = requestAnimationFrame(this.animation.bind(this));
    }

    dragMove(e) {
      if (!this.isDragging) return;
      const currentX = this.getPositionX(e);
      const currentY = this.getPositionY(e);
      const diffX = currentX - this.startX;
      const diffY = currentY - this.startY;

      if (Math.abs(diffX) > 8 || Math.abs(diffY) > 8) {
        this.dragMoved = true;
      }

      this.currentTranslate = this.prevTranslate + diffX;
    }

    dragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      cancelAnimationFrame(this.animationId);

      const movedBy = this.currentTranslate - this.prevTranslate;

      if (movedBy < -40) {
        this.currentIndex++;
      } else if (movedBy > 40) {
        this.currentIndex--;
      }

      this.updatePosition(true);
    }

    getPositionX(e) {
      return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    }

    getPositionY(e) {
      return e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    }

    animation() {
      if (this.isDragging) {
        this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        requestAnimationFrame(this.animation.bind(this));
      }
    }

    setupCardHoverAndClicks() {
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      this.track.querySelectorAll('.vrc-card').forEach((card) => {
        const video = card.querySelector('.vrc-card__video');
        const addToCartBtn = card.querySelector('.vrc-card__add-to-cart');
        const jsonScript = card.querySelector('.vrc-product-json');

        // Add to cart click handler
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (jsonScript) {
              try {
                const productData = JSON.parse(jsonScript.textContent);
                this.onAddToCartClick(productData, addToCartBtn);
              } catch (err) {
                const variantId = addToCartBtn.getAttribute('data-variant-id');
                this.executeAddToCart(variantId, addToCartBtn);
              }
            } else {
              const variantId = addToCartBtn.getAttribute('data-variant-id');
              this.executeAddToCart(variantId, addToCartBtn);
            }
          });
        }

        // Card click / tap handler
        card.addEventListener('click', (e) => {
          if (this.dragMoved) return;
          if (e.target.closest('.vrc-card__add-to-cart')) return;
          this.openLightbox(video);
        });

        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.openLightbox(video);
          }
        });

        // Hover effect for desktop
        if (!isTouchDevice && video) {
          card.addEventListener('mouseenter', () => {
            this.startHoverVideo(card, video);
          });

          card.addEventListener('mouseleave', () => {
            this.stopHoverVideo(card, video);
          });
        }
      });
    }

    startHoverVideo(card, video) {
      if (this.activeCard && this.activeCard !== card) {
        const prevVideo = this.activeCard.querySelector('.vrc-card__video');
        if (prevVideo) this.stopHoverVideo(this.activeCard, prevVideo);
      }

      this.activeCard = card;
      card.classList.add('is-playing');

      if (video.readyState === 0) {
        video.load();
      }

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }

      if (this.activeTimer) clearTimeout(this.activeTimer);
      this.activeTimer = setTimeout(() => {
        this.stopHoverVideo(card, video);
      }, 5000);
    }

    stopHoverVideo(card, video) {
      if (this.activeTimer) clearTimeout(this.activeTimer);
      card.classList.remove('is-playing');
      video.pause();
      video.currentTime = 0;
      if (this.activeCard === card) this.activeCard = null;
    }

    openLightbox(sourceVideo) {
      if (!this.lightbox || !this.lightboxVideo) return;

      if (this.activeCard) {
        const video = this.activeCard.querySelector('.vrc-card__video');
        if (video) this.stopHoverVideo(this.activeCard, video);
      }

      this.lightboxVideo.pause();
      this.lightboxVideo.innerHTML = '';

      if (sourceVideo) {
        const sources = sourceVideo.querySelectorAll('source');
        if (sources.length > 0) {
          sources.forEach((src) => {
            const clone = src.cloneNode(true);
            this.lightboxVideo.appendChild(clone);
          });
        } else if (sourceVideo.src) {
          this.lightboxVideo.src = sourceVideo.src;
        }
      }

      this.lightboxVideo.load();
      this.lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      const playPromise = this.lightboxVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }

      if (this.lightboxClose) this.lightboxClose.focus();
    }

    closeLightbox() {
      if (!this.lightbox || !this.lightboxVideo) return;
      this.lightboxVideo.pause();
      this.lightboxVideo.currentTime = 0;
      this.lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    onAddToCartClick(productData, button) {
      if (!productData) return;

      // If product has only 1 variant or default variant, add directly
      if (productData.has_only_default_variant || !productData.variants || productData.variants.length <= 1) {
        const variantId = (productData.variants && productData.variants[0]) ? productData.variants[0].id : button.getAttribute('data-variant-id');
        this.executeAddToCart(variantId, button, productData.title);
      } else {
        // Open Variant Selection Modal
        this.openVariantModal(productData, button);
      }
    }

    openVariantModal(productData, triggerButton) {
      if (!this.variantModal) return;

      this.currentProductData = productData;
      this.currentTriggerButton = triggerButton;

      if (this.variantImg) this.variantImg.src = productData.featured_image || '';
      if (this.variantTitle) this.variantTitle.textContent = productData.title;

      // Reset options selection
      this.selectedOptions = productData.options.map((opt) => opt.values[0]);

      this.renderVariantOptions();
      this.updateSelectedVariantState();

      this.variantModal.removeAttribute('hidden');
    }

    renderVariantOptions() {
      if (!this.variantOptionsBody || !this.currentProductData) return;

      this.variantOptionsBody.innerHTML = '';

      this.currentProductData.options.forEach((opt, optIdx) => {
        const group = document.createElement('div');
        group.className = 'vrc-variant-modal__options-group';

        const label = document.createElement('span');
        label.className = 'vrc-variant-modal__option-label';
        label.textContent = opt.name;
        group.appendChild(label);

        const pillsContainer = document.createElement('div');
        pillsContainer.className = 'vrc-variant-modal__pills';

        opt.values.forEach((val) => {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = `vrc-variant-pill ${this.selectedOptions[optIdx] === val ? 'selected' : ''}`;
          pill.textContent = val;

          pill.addEventListener('click', () => {
            this.selectedOptions[optIdx] = val;
            this.renderVariantOptions();
            this.updateSelectedVariantState();
          });

          pillsContainer.appendChild(pill);
        });

        group.appendChild(pillsContainer);
        this.variantOptionsBody.appendChild(group);
      });
    }

    findMatchingVariant() {
      if (!this.currentProductData || !this.currentProductData.variants) return null;
      return this.currentProductData.variants.find((v) => {
        return v.options.every((optVal, idx) => optVal === this.selectedOptions[idx]);
      });
    }

    updateSelectedVariantState() {
      const matched = this.findMatchingVariant();

      if (matched) {
        if (this.variantPrice) this.variantPrice.textContent = matched.price;

        if (matched.available) {
          this.variantSubmitBtn.disabled = false;
          this.variantSubmitBtn.querySelector('span').textContent = 'Add to cart';
        } else {
          this.variantSubmitBtn.disabled = true;
          this.variantSubmitBtn.querySelector('span').textContent = 'Sold out';
        }

        // Re-bind click for submit button
        this.variantSubmitBtn.onclick = () => {
          this.closeVariantModal();
          this.executeAddToCart(matched.id, this.currentTriggerButton, `${this.currentProductData.title} (${matched.title})`);
        };
      } else {
        if (this.variantPrice) this.variantPrice.textContent = '';
        this.variantSubmitBtn.disabled = true;
        this.variantSubmitBtn.querySelector('span').textContent = 'Unavailable';
      }
    }

    closeVariantModal() {
      if (!this.variantModal) return;
      this.variantModal.setAttribute('hidden', '');
    }

    executeAddToCart(variantId, button, customTitle = '') {
      if (!variantId || button?.dataset.cartPending === 'true') return;

      if (button) {
        button.disabled = true;
        button.dataset.cartPending = 'true';
      }
      const plusIcon = button?.querySelector('.vrc-icon-plus');
      const checkIcon = button?.querySelector('.vrc-icon-check');

      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
        : 'cart-drawer,cart-icon-bubble';

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }

      const previousRequest = window.bonezCartAddQueue || Promise.resolve();
      const currentRequest = previousRequest
        .catch(() => {})
        .then(() => this.requestCartAdd(variantId, sectionsToRender))
        .then((data) => {
          // 1. Notify Dawn PubSub event if active
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'video-reviews-carousel',
              productVariantId: variantId,
              cartData: data,
            });
          }

          // 2. Update and open Cart Drawer / Notification using native Dawn component
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else {
            // Fallback: manually update cart icon bubble
            if (data.sections && data.sections['cart-icon-bubble']) {
              const bubbleHtml = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const newBubble = bubbleHtml.querySelector('#cart-icon-bubble') || bubbleHtml.querySelector('.shopify-section');
              const currentBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
            }
          }
          if (cartDrawer?.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

          // 3. Show Toast feedback
          const message = customTitle ? `${customTitle} added to cart!` : 'Item added to cart!';
          this.showToastMessage(message);

          // 4. Button feedback animation
          if (plusIcon) plusIcon.classList.add('hidden');
          if (checkIcon) checkIcon.classList.remove('hidden');

          setTimeout(() => {
            if (plusIcon) plusIcon.classList.remove('hidden');
            if (checkIcon) checkIcon.classList.add('hidden');
            if (button) {
              button.disabled = false;
              delete button.dataset.cartPending;
            }
          }, 1500);
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          if (button) {
            button.disabled = false;
            delete button.dataset.cartPending;
          }
        });

      window.bonezCartAddQueue = currentRequest.catch(() => {});
    }

    async requestCartAdd(variantId, sectionsToRender) {
      const maxAttempts = 4;

      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const responseText = await response.text();
        let data = null;

        try {
          data = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          data = null;
        }

        if (response.status === 429 && attempt < maxAttempts - 1) {
          await new Promise((resolve) => setTimeout(resolve, this.getCartRetryDelay(response, attempt)));
          continue;
        }

        if (!response.ok || data?.status) {
          throw new Error(data?.description || data?.message || `Could not add item to cart (${response.status})`);
        }

        if (!data) throw new Error('Could not read the cart response');
        return data;
      }

      throw new Error('Could not add item to cart');
    }

    getCartRetryDelay(response, attempt) {
      const retryAfter = response.headers.get('Retry-After');
      const retryAfterSeconds = Number.parseFloat(retryAfter);

      if (Number.isFinite(retryAfterSeconds)) {
        return Math.max(250, retryAfterSeconds * 1000);
      }

      const retryDate = retryAfter ? Date.parse(retryAfter) : NaN;
      if (!Number.isNaN(retryDate)) {
        return Math.max(250, retryDate - Date.now());
      }

      return 2000 * (2 ** attempt);
    }

    showToastMessage(msg) {
      if (!this.toast) return;

      const msgEl = this.toast.querySelector('.vrc-toast__message');
      if (msgEl) msgEl.textContent = msg;

      this.toast.classList.add('active');

      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.classList.remove('active');
      }, 3500);
    }
  }

  if (!customElements.get('video-reviews-carousel')) {
    customElements.define('video-reviews-carousel', VideoReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
